import { createAction } from "redux-actions";

import { IScormPackage } from "../../types/common";

export enum Action {
  DELETE_SCORM_PACKAGE = "DELETE_SCORM_PACKAGE",
  DELETE_SCORM_PACKAGE_FAILURE = "DELETE_SCORM_PACKAGE_FAILURE",
  DELETE_SCORM_PACKAGE_SUCCESS = "DELETE_SCORM_PACKAGE_SUCCESS",
  FETCH_EXPORTED_SCORM_PACKAGES = "FETCH_EXPORTED_SCORM_PACKAGES",
  FETCH_EXPORTED_SCORM_PACKAGES_FAILURE = "FETCH_EXPORTED_SCORM_PACKAGES_FAILURE",
  FETCH_EXPORTED_SCORM_PACKAGES_SUCCESS = "FETCH_EXPORTED_SCORM_PACKAGES_SUCCESS",
  MOUNT = "MOUNT",
  UNMOUNT = "UNMOUNT",
}

export const deleteScormPackage = createAction<string>(Action.DELETE_SCORM_PACKAGE);
export const deleteScormPackageFailure = createAction<{ message: string }>(Action.DELETE_SCORM_PACKAGE_FAILURE);
export const deleteScormPackageSuccess = createAction<IScormPackage[]>(Action.DELETE_SCORM_PACKAGE_SUCCESS);
export const fetchExportedScormPackages = createAction<void>(Action.FETCH_EXPORTED_SCORM_PACKAGES);
export const fetchExportedScormPackagesFailure = createAction<{
  message: string;
}>(Action.FETCH_EXPORTED_SCORM_PACKAGES_FAILURE);
export const fetchExportedScormPackagesSuccess = createAction<IScormPackage[]>(
  Action.FETCH_EXPORTED_SCORM_PACKAGES_SUCCESS
);
export const mount = createAction<void>(Action.MOUNT);
export const unmount = createAction<void>(Action.UNMOUNT);
